import Skeleton from "../../../common/ui/skeletons/base"

const PaymentMethodsSkeleton = () => (
  <div className="my-6 space-y-4">
    {Array.from({ length: 2 }).map((_, index) => (
      <div
        key={index}
        className="bg-white border border-gray-200 rounded-lg px-4 py-6"
      >
        <Skeleton>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {/* Card icon skeleton */}
              <div className="w-8 h-8 bg-gray-200 rounded"></div>

              <div className="space-y-2">
                {/* Brand and card number */}
                <div className="flex items-center space-x-2">
                  <div className="h-4 w-16 bg-gray-200 rounded"></div>
                  <div className="h-4 w-24 bg-gray-100 rounded"></div>
                </div>

                {/* Expiration date */}
                <div className="h-3 w-28 bg-gray-100 rounded"></div>
              </div>
            </div>

            {/* Action buttons skeleton */}
            <div className="flex space-x-2">
              <div className="h-6 w-6 bg-gray-200 rounded"></div>
            </div>
          </div>
        </Skeleton>
      </div>
    ))}
  </div>
)

export default PaymentMethodsSkeleton
